import { useState, useRef, useEffect } from 'react'

import { useDebounce } from 'core/hooks'

const useHasRecentlyChanged = (time = 400) => {
  const [recentlyChanged, setRecentlyChanged] = useState(false)
  const ref = useRef()
  const onRecentChange = () => {
    setRecentlyChanged(true)
    clearTimeout(ref.current)
    ref.current = setTimeout(() => setRecentlyChanged(false), time)
  }
  useEffect(() => () => clearTimeout(ref.current), [])

  return { recentlyChanged, onRecentChange }
}

const useAsyncOnChange = ({ value = '', onChange = (_value) => {} } = {}) => {
  const [localValue, setLocalValue] = useState(value)

  const { recentlyChanged, onRecentChange } = useHasRecentlyChanged(250)

  const throttledOnChange = useDebounce(onChange, 150)

  const handleChange = (value) => {
    setLocalValue(value)
    onRecentChange()
    throttledOnChange(value)
  }

  const isChanged = localValue !== value

  useEffect(() => {
    if (!recentlyChanged) {
      setLocalValue(value)
    }
    // if the the local value hasn't changed (via onChange) for a while,
    // and then the passed value changes, set the local
  }, [value])

  return {
    value: localValue,
    onChange: handleChange,
    isChanged,
    isFocused: recentlyChanged,
  }
}

export default useAsyncOnChange
